<template>
	<div>
		<b-card>
			<vs-sidebar :click-not-close="true" position-right parent="body"  default-index="1" color="primary"
						class="create-modal" spacer v-model="sidebar">
				<b-container>
					<div class="goods-form-wrapper">
						<div class="header-sidebar mb-4">
							<h4 class="pull-left">
								Новая Регулировка
							</h4>
							<b-button class="pull-right close-btn" @click="cancel" type="button" variant="link"><i class="fa fa-close"></i></b-button>
							<div class="clearfix"></div>
							<hr>
						</div>
						<Create :mode="mode" @cancel="cancel" @ok="ok" :item="item" @edit="editAdj"></Create>
					</div>
				</b-container>
			</vs-sidebar>
			<div slot="header">{{ $t('sidebar.warehouse-management.adjustment') }}
				<div class="card-header-actions">
					<b-link @click="create(null,'create')" class="card-header-action btn-setting"><i class="fa fa-plus-circle"></i></b-link>
				</div>
			</div>
			<b-card-body>

				<!-- TABLE -->
				<div class="table-responsive table-wrapper">
					<b-table responsive="true" class="generalTableClass"
							 :items="items"
							 :fields="refField"
							 :current-page="search.limit"
							 :per-page="0"
							 hover="hover"
							 striped="striped"
							 bordered="bordered"
							 show-empty
					>
						<template slot="actions" slot-scope="data">
							<!--<b-link :key="data.item.id + 'delete'"
									@click=""
									:id="'popOverDelete'+data.item.id"
							>
								<i class="fa fa-trash"></i>
							</b-link>-->
							<b-link
									@click="create(data.item,'edit')"
							>
								<i class="fa fa-edit"></i>
							</b-link>
						</template>
					</b-table>
<!--					<div v-if="loader" class="spinner-wrapper">-->
<!--						<b-spinner variant="primary"></b-spinner>-->
<!--					</div>-->
				</div>
				<!-- TABLE -->

				<nav>
					<b-pagination :total-rows="total" :per-page="search.limit" v-model="search.page"
								  :prev-text="$t('pagination.prev')"
								  :next-text="$t('pagination.next')" hide-goto-end-buttons/>
				</nav>

			</b-card-body>
		</b-card>

	</div>
</template>

<script>
import Create from "./blocks/Create";
import WhDocument from "../../../services/wh-document.service";

export default {

    	/**
		 *
		 */
		name: 'Adjustment',
		components: {Create},
		/**
		 *
		 * @returns {{sidebar: boolean}}
		 */
		data() {
        	return {
        		sidebar: false,
				search: {
					page: 1,
        			limit: 20,
					attributes: [],
				},
				mode:'create',
				item: null,
				total: 0,
				items:[],
				refField: [
					{
						key: 'id',
						label: 'ID',
						sortable: true,
						visible: true,
					},
					{
						key: 'regDate',
						label: this.$t('incomes.date'),
						sortable: true,
						visible: true,
					},
					{
						key: 'departmentName',
						label: this.$t('incomes.department'),
						sortable: true,
						visible: true,
					},
					{
						key: 'fio',
						label: this.$t('employees.full-name'),
						sortable: true,
						visible: true,
					},
					{
						key: 'shortageTypeName',
						label: this.$t('pending.rosxojdeniya'),
						sortable: true,
						visible: true,
					},
					{
						key: 'comment',
						label: this.$t('client.create.comment'),
						sortable: true,
						visible: true,
					},
					{
						key: 'actions',
						label: this.$t('goods.actions'),
						'class': 'table_actions',
						visible: true,
					}

				],
			}
		},

		/**
		 *
		 */
		methods: {

			/**
			 * create method
			 */
			create(item = null, mode) {
				this.item = item;
				this.mode = null;
				this.mode = mode;
				setTimeout(() => {
					this.openSidebar();
				}, 100);

			},

			 async getlist(){
				 await WhDocument.getAdjList(this.search).then(response => {
				 	this.total  = response.total
					this.items = response.items
				})
			},

			/**
			 * edit method
			 */
			edit() {

			},

			/**
			 * Open sidebar
			 */
			openSidebar() {
        		setTimeout(() => { this.sidebar = true }, 200)
			},

			cancel() {
				this.mode='create'
				this.sidebar = false;
			},
			ok(obj){
				WhDocument.adjustmentAdd(obj).then(response => {
					this.getlist();
					this.sidebar = false;
				})
			},
			editAdj(obj){
				WhDocument.adjustmentEdit(obj).then(response => {
					this.getlist();
					this.sidebar = false;
				})
			}
		},
		watch:{
			'search.page':{
				handler(){
					this.getlist()
				}
			},
		},

		async created() {
			 await this.getlist();

		}
	}
</script>

<style scoped>

</style>
